// Imported for side effects (module augmentation)
import './occ-storefinder-endpoints.model';
